import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { ComponentSync } from '../core/ComponentSync.js';
import { ModuleFE_ServerInfo } from './ModuleFE_ServerInfo.js';
import './Button_VersionUpdate.scss';
export class Button_VersionUpdate extends ComponentSync {
    __onServerInfoUpdated = () => {
        this.forceUpdate();
    };
    updateVersion = async () => {
        if (this.props.updateVersion) {
            this.props.updateVersion();
            return;
        }
        ModuleFE_ServerInfo.Update.updateAndRefreshPage();
    };
    getLatestVersion() {
        return ModuleFE_ServerInfo.Version.getLatestVersion();
    }
    getButtonToRender() {
        const ButtonContent = this.props.buttonContent ? this.props.buttonContent : `Version ${this.getLatestVersion()} available. Click to update`;
        return _jsx("div", { className: 'version-update-message', onClick: () => this.updateVersion(), children: ButtonContent });
    }
    render() {
        const shouldUpdateVersion = ModuleFE_ServerInfo.Version.shouldUpdateVersion();
        if (!shouldUpdateVersion)
            return _jsx(_Fragment, {});
        return this.getButtonToRender();
    }
}
//# sourceMappingURL=Button_VersionUpdate.js.map